/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authenticatorsDeleteAuthenticatorConnection } from "../../funcs/authenticatorsDeleteAuthenticatorConnection.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteAuthenticatorConnectionRequest$inboundSchema,
};

export const tool$authenticatorsDeleteAuthenticatorConnection: ToolDefinition<
  typeof args
> = {
  name: "authenticators-delete-authenticator-connection",
  description: `Delete Authenticator

Delete an authenticator. This requires all connections created by that authenticator to be deleted first.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authenticatorsDeleteAuthenticatorConnection(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
